var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-round-svgrepo-com 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 13.9998C11.3137 13.9998 14 11.3134 14 7.99976C14 4.68605 11.3137 1.99976 8 1.99976C4.68629 1.99976 2 4.68605 2 7.99976C2 8.95958 2.22537 9.86672 2.62608 10.6713C2.73256 10.885 2.76801 11.1294 2.70627 11.3601L2.34891 12.6958C2.19377 13.2756 2.72421 13.806 3.30401 13.6509L4.63963 13.2935C4.87036 13.2318 5.11473 13.2672 5.32852 13.3737C6.13302 13.7744 7.04018 13.9998 8 13.9998Z",
    stroke: "#1C274C",
    strokeWidth: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.68ed7edfe88bf7ac8fc69053682ce1f7.svg";
export { ForwardRef as ReactComponent };